import { useSound } from '../contextes/SoundContext';
import '../styles/SoundIcon.css';

import { Volume2, VolumeOff } from 'lucide-react';

// Props du composant SoundIcon
type SoundIconProps = {
    isTransparent?: boolean;
    buttonVariant?: 'primary' | 'tertiary';
};

// Composant pour afficher une icône de son (on/off) avec un bouton

const SoundIcon: React.FC<SoundIconProps> = ({
    isTransparent = false,
    buttonVariant = 'primary',
}) => {
    // Import des gestionnaires du contexte Sound
    const { isSoundOn, toggleSound } = useSound();

    return (
        <button
            onClick={toggleSound}
            className={`${
                isTransparent
                    ? 'button-transparent'
                    : buttonVariant === 'primary'
                      ? 'button-vert-clair'
                      : 'button-vert-fonce'
            } button-header sound-container`}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        >
            {isSoundOn ? <Volume2 size='1.2rem' /> : <VolumeOff size='1.2rem' />}
        </button>
    );
};

export default SoundIcon;
